import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Roles } from '../../features/users/services/create-user/create-user-state.service';
import { HotelInformation } from '../models/hotel-information.model';
import { CleanFlow } from '../models/clean-flow.models';

@Injectable({
  providedIn: 'root',
})
export class ReferenceService {
  private readonly apiSvc = inject(ApiService);

  getRoles() {
    return this.apiSvc.get<Roles[]>(`Reference/role`);
  }

  getRolesByFunction(func: string) {
    return this.apiSvc.get<Roles[]>(`Reference/roles/${func}`);
  }

  getHotelInformation() {
    return this.apiSvc.get<HotelInformation>(`Reference/Hotel`);
  }

  getAdminHotelInformation() {
    return this.apiSvc.get<HotelInformation>(`Reference/Admin/Hotel`);
  }

  getCleanFlows() {
    return this.apiSvc.get<CleanFlow[]>(`Reference/clean/wfs`);
  }
}
